// extracted by mini-css-extract-plugin
export default {"container":"stats_container__0NMl8","items":"stats_items__p-nTJ","label":"stats_label__y+R9X","value":"stats_value__07wA-"};